import { BrowserRouter as Router, Routes, Route, NavLink, useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect, useState, useAuthState} from 'react';
import { onAuthStateChanged, signOut, } from 'firebase/auth';
import { auth } from './firebase';

import PackageDashboard from './components/Dashboard/PackageDashboard';
import PackageDetail from './PackageDetail';
import AddPackage from './AddPackage';
import SignInPage from './SignIn';
import ProtectedRoute from './ProtectedRoute';
import Sidebar from './components/Sidebar/Sidebar';
import Summary from './components/Summary/Summary';
import QRScanner from './components/QRScanner/QRScanner';
import ShippingLabel from './components/ShippingLabel/ShippingLabel';
import PaymentHistory from './Payment';
import PaymentForm from './components/PaymentForm/PaymentForm'
import Returns from './Returns';
import OwnerRoute from './OwnerRoute';
import AdminOrOwnerRoute from './AdminOrOwnerRoute';
import RoleRoute from './RoleRoute';
import { canReconcile } from './roles';
import DriverSummary from './components/DriverSummary/DriverSummary';
import PaymentRecord from './components/PaymentRecord/PaymentRecord'; 
import UserPackageSummary from './components/UserPackageSummary/UserPackageSummary'; 
import UserPackageDetail from './components/UserPackageDetail/UserPackageDetail'; 
import DeliveryDashboard from './components/DeliveryDashboard/DriverDeliveryDashboard'; 
import UserAdmin from './components/UserAdmin/AdminUserManagement.js'; 
import Reconciliation from './components/Reconciliations/PaymentReconciliation.js'; 




const AppContent = ({ user, handleSignOut, sidebarCollapsed, toggleSidebar }) => {
  const location = useLocation();
  const isAuthPage = location.pathname === '/signin';

  if (isAuthPage) {
    return (
      <div className="flex h-screen w-full bg-[#1e293b] justify-center items-center overflow-y-auto">
        <div className="w-full max-w-md px-4">
          <Routes>
            <Route path="/signin" element={<SignInPage />} />
          </Routes>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen w-full bg-gray-50 justify-start">
      {user && (
        <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      )}

      <div
        className={`flex-1 transition-all duration-300 w-full flex ${
          user ? 'lg:ml-72' : ''
        }`}
      >
        <main className="p-4 w-full overflow-y-auto">
          <Routes>
            <Route path="/add" element={<ProtectedRoute><AddPackage /></ProtectedRoute>} />
            <Route path="/packages" element={<ProtectedRoute><PackageDashboard /></ProtectedRoute>} />
            <Route path="/package/:id" element={<ProtectedRoute><PackageDetail /></ProtectedRoute>} />
            <Route path="/shipping-label/:id" element={<ProtectedRoute><ShippingLabel /></ProtectedRoute>} />
            <Route path="/scanner" element={<ProtectedRoute><QRScanner /></ProtectedRoute>} />
            <Route path="*" element={<ProtectedRoute><PackageDashboard /></ProtectedRoute>} />
            <Route path="/summary" element={<ProtectedRoute><AdminOrOwnerRoute><Summary /></AdminOrOwnerRoute></ProtectedRoute>} />
            <Route path="/paymentForm" element={<ProtectedRoute><PaymentForm /></ProtectedRoute>} />
            <Route path="/paymentForm/:id" element={<ProtectedRoute><PaymentForm /></ProtectedRoute>} />
            <Route path="/driverSummary" element={<ProtectedRoute><DriverSummary /></ProtectedRoute>} />
            <Route path="/paymentHistory" element={<ProtectedRoute><OwnerRoute><PaymentHistory /></OwnerRoute></ProtectedRoute>} />
            <Route path="/paymentRecord" element={<ProtectedRoute><AdminOrOwnerRoute><PaymentRecord /></AdminOrOwnerRoute></ProtectedRoute>} />
            <Route path="/returns" element={<ProtectedRoute><AdminOrOwnerRoute><Returns /></AdminOrOwnerRoute></ProtectedRoute>} />
            <Route path="/userpackagesummary" element={<ProtectedRoute><OwnerRoute><UserPackageSummary /></OwnerRoute></ProtectedRoute>} />
            <Route path="/deliveryDashboard" element={<ProtectedRoute><OwnerRoute><DeliveryDashboard /></OwnerRoute></ProtectedRoute>} />
            <Route path="/userpackagedetail/:staffName" element={<ProtectedRoute><OwnerRoute><UserPackageDetail /></OwnerRoute></ProtectedRoute>} />
            <Route path="/useradmin" element={<ProtectedRoute><OwnerRoute><UserAdmin /></OwnerRoute></ProtectedRoute>} />
            <Route path="/reconciliation" element={<ProtectedRoute><RoleRoute allow={canReconcile}><Reconciliation /></RoleRoute></ProtectedRoute>} />

          </Routes>
        </main>
      </div>
    </div>
  );
};

const App = () => {
  const [user, setUser] = useState(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(window.innerWidth < 768);
  
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => setUser(u));
    
    // Add responsive sidebar collapse for mobile
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSidebarCollapsed(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    handleResize(); // Check on initial load
    
    return () => {
      <div className="flex">
        {unsubscribe()}
        {window.removeEventListener('resize', handleResize)}
      </div>
    };
  }, []);

  const toggleSidebar = () => setSidebarCollapsed(prev => !prev);

  const handleSignOut = async () => {
    await signOut(auth);
  };

  return (
    <Router>
      <AppContent
        user={user}
        handleSignOut={handleSignOut}
        sidebarCollapsed={sidebarCollapsed}
        toggleSidebar={toggleSidebar}
      />
    </Router>
  );
};

export default App;